import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OkCancelDialog} from '../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {Paragraph} from '../../../../../libs/shared/ui/src/components/utility/paragraph';

/*
 * Props.
 */

interface ViewerReplaceDraftDialogProps {
  onConfirmReplaceDraft: (() => void) | undefined;
  onRequestClose: () => void;
}

/*
 * Component.
 */

export const ViewerReplaceDraftDialog: FC<ViewerReplaceDraftDialogProps> = ({
  onConfirmReplaceDraft,
  onRequestClose,
}) => {
  if (!onConfirmReplaceDraft) {
    return null;
  }

  const onOkClick = () => {
    onConfirmReplaceDraft();
    onRequestClose();
  };

  return (
    <OkCancelDialog
      title={<Trans id="message-viewier-replace-draft">Delete current draft?</Trans>}
      okButtonLabel={<Trans id="message-viewier-replace-draft-ok">Replace current draft</Trans>}
      onOkClick={onOkClick}
      onRequestClose={onRequestClose}
    >
      <Trans id="message-viewer-replace-draft-content">
        <Paragraph>Are you sure you want to delete your current draft and start a new one?</Paragraph>
        <Paragraph>This action cannot be undone.</Paragraph>
      </Trans>
    </OkCancelDialog>
  );
};
